module.exports = __webpack_public_path__ + "img/1548807917.03e3a0c5.jpg";